'use strict';

(() => {
  const template = document.createElement('template');

  template.innerHTML = /* html */ `
    <style>
      h5 { font-size: 1.25rem; margin-top: 0; margin-bottom: .5rem; font-weight: 500; line-height: 1.2; display: block; }
      hr { margin: 1rem 0; color: inherit; border: 0; border-top: 1px solid; opacity: .25; }
    </style>

    <div>
      <h5><slot></slot></h5>
      <hr>
    </div>
    `;

  class DefaultFieldSub extends HTMLElement {
    #root = null;

    constructor() {
      super();
      this.#root = this.attachShadow({ mode: 'open' });
      this.#root.appendChild(template.content.cloneNode(true));
    }
  }

  customElements.define('default-field-sub', DefaultFieldSub);
})();
